// DocumentosTareas.js
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

import { socket } from "../../socket";

import { Delete } from "@mui/icons-material";
import dayjs from "dayjs";
import {
  getDocumentosByTarea,
  uploadDocumentoTarea,
  deleteDocumentoTarea,
} from "../../api/Tareas/documentosTareasApi";
import Slide from "@mui/material/Slide";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const tipos = [
  "Spec Sheet",
  "Pattern",
  "Fitting Video",
  "Client Comments",
  "Otros",
];

const DocumentosTareas = ({ id_Tarea, onDocsChange }) => {
  const [documentos, setDocumentos] = useState([]);
  const [archivo, setArchivo] = useState(null);
  const [tipo, setTipo] = useState("");

  // 🔹 Fecha por defecto = hoy
  const [fecha, setFecha] = useState(dayjs().format("YYYY-MM-DD"));

  const [openDialog, setOpenDialog] = useState(false);
  const [docToDelete, setDocToDelete] = useState(null);

  const [previewImage, setPreviewImage] = useState(null);
  const [previewName, setPreviewName] = useState("");

  const handlePreview = (url, name) => {
    setPreviewImage(url);
    setPreviewName(name);
  };

  useEffect(() => {
    if (id_Tarea) loadDocs();
  }, [id_Tarea]);

  const loadDocs = async () => {
    const data = await getDocumentosByTarea(id_Tarea);
    setDocumentos(data);
  };

  const handleUpload = async () => {
    if (!archivo?.length) return;
    for (let i = 0; i < archivo.length; i++) {
      await uploadDocumentoTarea(archivo[i], id_Tarea, tipo, fecha);
    }
    setArchivo(null);
    setTipo("");
    setFecha("");
    await loadDocs();

    // 🔹 Notifica al padre (si existe)
    if (onDocsChange) onDocsChange();

    // 🔹 Lanza evento global (para ToDoListGlobal)
    socket.emit("tareas-documento-actualizado", { tareaId: id_Tarea });
  };

  const handleDelete = async () => {
    await deleteDocumentoTarea(docToDelete);
    setOpenDialog(false);
    setDocToDelete(null);
    await loadDocs();

    // 🔹 Notifica al padre (si existe)
    if (onDocsChange) onDocsChange();

    // 🔹 Lanza evento global (para ToDoListGlobal)
    socket.emit("tareas-documento-actualizado", { tareaId: id_Tarea });
  };

  useEffect(() => {
    const handleDocUpdate = ({ tareaId }) => {
      if (tareaId === id_Tarea) loadDocs();
    };
    socket.on("tareas-documento-actualizado", handleDocUpdate);
    return () => socket.off("tareas-documento-actualizado", handleDocUpdate);
  }, [id_Tarea]);

  const API = process.env.REACT_APP_API_URL;

  return (
    <Box
      sx={{
        p: 2,
        border: "1px solid #ddd",
        borderRadius: 2,
        mt: 2,
      }}
    >
      <Typography variant="h6" sx={{ mb: 1 }}>
        Task Documents
      </Typography>

      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2 }}>
        <TextField
          select
          label="Tipo"
          size="small"
          value={tipo}
          onChange={(e) => setTipo(e.target.value)}
          sx={{ minWidth: 240, ml: 0.5 }}
        >
          {tipos.map((t) => (
            <MenuItem key={t} value={t}>
              {t}
            </MenuItem>
          ))}
        </TextField>

        {/*   <TextField
          label="Expiration"
          type="date"
          size="small"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: 150 }}
        /> */}

        <Button variant="outlined" component="label" sx={{ minWidth: 150 }}>
          Select File(s)
          <input
            hidden
            type="file"
            multiple
            onChange={(e) => setArchivo(e.target.files)}
          />
        </Button>

        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={!archivo || !tipo}
          sx={{ minWidth: 120 }}
        >
          Upload
        </Button>
      </Box>

      {archivo?.length > 0 && (
        <Typography variant="body2" sx={{ color: "#555", mt: -1, mb: 1 }}>
          {archivo.length} file{archivo.length > 1 ? "s" : ""} selected
        </Typography>
      )}

      {/*  Miniaturas de documentos */}
      {/* 🗂️ Lista de documentos con scroll fijo */}
      <Box
        sx={{
          maxHeight: "min(60vh, 550px)",
          overflowY: "auto",
          pr: 1,
          pl: 0.5,
          mt: 1,
          "&::-webkit-scrollbar": {
            width: 8,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#ccc",
            borderRadius: 4,
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#999",
          },
        }}
      >
        {documentos.length === 0 && (
          <Typography variant="body2" sx={{ color: "#777", p: 1 }}>
            No documents uploaded yet.
          </Typography>
        )}

        {documentos.map((doc) => {
          const fileName = doc.Archivo.split("/").pop();
          const url = `${API}/uploads/tareas/${doc.Archivo}`;
          const isImage = /\.(png|jpe?g|gif|webp)$/i.test(fileName);
          const isPdf = /\.pdf$/i.test(fileName);

          return (
            <Box
              key={doc.id_Documento}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 1.2,
                p: 1,
                borderRadius: 2,
                border: "1px solid #ddd",
                backgroundColor: "#fafafa",
                transition: "background 0.2s",
                "&:hover": { backgroundColor: "#f5f5f5" },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                {isImage ? (
                  <Box
                    component="img"
                    src={url}
                    alt={fileName}
                    sx={{
                      width: 70,
                      height: 70,
                      objectFit: "cover",
                      borderRadius: 1,
                      border: "1px solid #ccc",
                      cursor: "pointer",
                      transition: "transform 0.2s ease",
                      "&:hover": { transform: "scale(1.05)" },
                    }}
                    onClick={() => handlePreview(url, fileName)}
                  />
                ) : isPdf ? (
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: "50%",
                      backgroundColor: "#d32f2f",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "0.8rem",
                      cursor: "pointer",
                    }}
                    onClick={() => window.open(url, "_blank")}
                  >
                    PDF
                  </Box>
                ) : (
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: "50%",
                      backgroundColor: "#90a4ae",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "0.75rem",
                      cursor: "pointer",
                    }}
                    onClick={() => window.open(url, "_blank")}
                  >
                    FILE
                  </Box>
                )}

                <Box>
                  <Typography sx={{ fontSize: "0.9rem", fontWeight: 600 }}>
                    {doc.TipoDocumento}
                  </Typography>
                  <Typography
                    component="a"
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    sx={{
                      display: "block",
                      color: "#2196f3",
                      textDecoration: "none",
                      "&:hover": { textDecoration: "underline" },
                      fontSize: "0.8rem",
                      maxWidth: 160,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {fileName}
                  </Typography>
                  {doc.FechaCaducidad && (
                    <Typography
                      sx={{ fontSize: "0.75rem", color: "#888", mt: 0.3 }}
                    >
                      Exp: {dayjs(doc.FechaCaducidad).format("DD/MM/YYYY")}
                    </Typography>
                  )}
                </Box>
              </Box>

              <IconButton
                size="small"
                onClick={() => {
                  setDocToDelete(doc.id_Documento);
                  setOpenDialog(true);
                }}
              >
                <Delete sx={{ color: "red" }} />
              </IconButton>
            </Box>
          );
        })}
      </Box>

      {/* 🔍 Lightbox de previsualización de imágenes */}
      <Dialog
        open={!!previewImage}
        onClose={() => setPreviewImage(null)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "rgba(0,0,0,0.85)",
            boxShadow: "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        }}
      >
        <IconButton
          onClick={() => setPreviewImage(null)}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            color: "#fff",
            zIndex: 10,
          }}
        >
          ✖
        </IconButton>

        {previewImage && (
          <Box
            component="img"
            src={previewImage}
            alt={previewName}
            sx={{
              maxWidth: "90%",
              maxHeight: "90vh",
              borderRadius: 2,
              boxShadow: "0 0 20px rgba(0,0,0,0.4)",
              objectFit: "contain",
            }}
          />
        )}
      </Dialog>

      {/* 🔴 Diálogo de confirmación de borrado */}
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpenDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            fontWeight: 700,
            color: "#d32f2f",
          }}
        >
          <WarningAmberIcon sx={{ color: "#d32f2f" }} />
          Confirm deletion
        </DialogTitle>

        <DialogContent>
          <DialogContentText sx={{ color: "#333", mb: 1 }}>
            Are you sure you want to permanently delete this document?
          </DialogContentText>

          {docToDelete && (
            <Box
              sx={{
                backgroundColor: "#f9f9f9",
                borderRadius: 1,
                p: 1,
                px: 2,
                border: "1px solid #ddd",
                color: "#444",
                fontSize: "0.85rem",
                fontFamily: "monospace",
              }}
            >
              {documentos
                .find((d) => d.id_Documento === docToDelete)
                ?.Archivo?.split("/")
                .pop() || "Unknown file"}
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ pr: 2, pb: 2 }}>
          <Button onClick={() => setOpenDialog(false)} color="inherit">
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleDelete}
            sx={{ fontWeight: 600 }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DocumentosTareas;
